import { z } from "zod";

import { constantsData } from "@/data";

export const setupOfflineDataSourceFormSchema = z.object({
    name: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
    sourceFile: z["instanceof"](
        File,
        {
            message: constantsData.msgs.requiredField,
        },
    ).refine(
        (file) => [".csv", ".xlsx", ".xls"].some((ext) => file.name.endsWith(ext)),
        constantsData.msgs.onlyAcceptCSVandXLSX,
    ),
    type: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
});
